import React, { useState } from 'react'
import IconButton from '@material-ui/core/IconButton'
import MenuIcon from '@material-ui/icons/Menu'
import Menu from '@material-ui/core/Menu'
import MenuItem from '@material-ui/core/MenuItem'
import useTheme from '@material-ui/core/styles/useTheme'
import makeStyles from '@material-ui/core/styles/makeStyles'
import { isFalsyOrEmpty } from './object'
import { useTranslation } from '../../contexts/i18n/use'

export const DropdownMenu = ({languages}) => {
  const theme = useTheme();
  const classes = useStyles(theme);
  const [anchorEl, setAnchorEl] = useState(null);
  const { actions: {t, updateLanguage }} = useTranslation();

  const handleOpenMenu = (event) => {
    setAnchorEl(event.currentTarget)
  }

  const handlePickMenuItem = (lang) => {
    updateLanguage(lang);
    setAnchorEl(null);
  }

  return (
    <>
      <IconButton edge="end" onClick={handleOpenMenu} classes={{root: classes.root}} >
        <MenuIcon className={classes.menuicon}  />
      </IconButton>
      <Menu
        id="simple-menu"
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={() => {setAnchorEl(null)}}
      >
        { !isFalsyOrEmpty(languages) ? languages.map(x => { return <MenuItem key={x} onClick={() => {handlePickMenuItem(x)}}>{x}</MenuItem>}) : <span/> }
        <hr/>
        <MenuItem onClick={() => window.open(t('header.visitproviderlink'))}>{t('header.visitprovider')}</MenuItem>
      </Menu>
    </>
  )
}

const useStyles = makeStyles({
  menuicon: theme => ({
    color: theme.palette.menu.main,
  }),
  root: {
      padding: '0.5rem'
  }
})



